import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { formatApiErrorDetail } from "../lib/api";
import { Scissors, Loader2 } from "lucide-react";

/* REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH */

export default function AuthCallback() {
  const nav = useNavigate();
  const { completeGoogleSession } = useAuth();
  const [error, setError] = useState("");
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      setError("Missing session_id");
      return;
    }
    const sessionId = decodeURIComponent(match[1]);
    // Clean URL immediately so a refresh doesn't retry
    window.history.replaceState(null, "", window.location.pathname);

    completeGoogleSession(sessionId)
      .then((data) => {
        if (data.is_super_admin && data.needs_onboarding) nav("/admin");
        else if (data.needs_onboarding) nav("/onboarding");
        else nav("/select-brand");
      })
      .catch((err) => {
        setError(formatApiErrorDetail(err.response?.data?.detail) || err.message || "Sign-in failed");
      });
  }, [completeGoogleSession, nav]);

  return (
    <div className="min-h-screen bg-[#FAFAFA] text-[#0A0A0A] flex items-center justify-center p-8" data-testid="auth-callback">
      <div className="max-w-md w-full text-center">
        <div className="inline-flex items-center gap-3 mb-8 justify-center">
          <Scissors size={22} className="text-[#0A0A0A]" strokeWidth={1.5}/>
          <div className="font-serif text-2xl tracking-widest">MMS HUB CENTER</div>
        </div>
        {!error ? (
          <>
            <Loader2 size={32} className="animate-spin text-[#0A0A0A] mx-auto mb-6"/>
            <div className="label-caps text-[#525252]">Finalizing sign-in…</div>
          </>
        ) : (
          <>
            <div className="text-red-600 text-sm mb-6" data-testid="auth-callback-error">{error}</div>
            <button onClick={() => nav("/login")} className="btn-gold">Back to sign-in</button>
          </>
        )}
      </div>
    </div>
  );
}
